export class Interactions {
  static ARCHIVE = 'archive';
  static CLOSE = 'close';
  static REMINDER = 'reminder';
  static VISIT = 'visit';
  static VISIT_CONFIRMATION = 'visit_confirmation';
  static CALENDAR = 'calendar';
  static CALENDAR_PREQUALIFICATION = 'calendar_prequalification';
  static FINISH_CALL = 'finish_call';
  static CALL_WITHOUT_ANSWER = 'call_without_answer';
  static CALL_ANSWER = 'call_answer';
  static TRANSITION_TO_ON_TRACK = 'transition_to_ontrack';
  static NOTHING = '';
  static REVERT_CLOSE = 'revert_close';
}
